"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delivering = void 0;
const dcterms_1 = require("lincd-dcmi/lib/ontologies/dcterms");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
let Delivering = class Delivering extends Shape_1.Shape {
    constructor(node) {
        super(node);
    }
    /**
     * This will automatically save the shape
     */
    async updateLastModified() {
        this.lastModified = new Date();
        await this.save();
    }
    /**
     * The date this shape was last modified, in UTC
     */
    get lastModified() {
        return new Date(this.getValue(dcterms_1.dcterms.modified));
    }
    set lastModified(val) {
        this.overwrite(dcterms_1.dcterms.modified, new models_1.Literal(`${val.toUTCString()}`));
    }
    get status() {
        return this.getValue(titan_ads_1.titanAds.deliveryStatus);
    }
    set status(val) {
        this.overwrite(titan_ads_1.titanAds.deliveryStatus, new models_1.Literal(val));
        this.updateLastModified();
    }
};
exports.Delivering = Delivering;
Delivering.targetClass = titan_ads_1.titanAds.Delivering;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.modified,
        required: true,
        dataType: xsd_1.xsd.dateTime,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Delivering.prototype, "lastModified", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.deliveryStatus,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Delivering.prototype, "status", null);
exports.Delivering = Delivering = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [models_1.NamedNode])
], Delivering);
//# sourceMappingURL=Delivering.js.map